import { Component, OnInit } from '@angular/core';

import { NgxUiLoaderService } from 'ngx-ui-loader';

import { Globals } from '../../_models/globals';

import { NotificationService } from '../../_services/notification.service';
import { RepairerManagerHoldingConfigService } from './holding-config.service';
import { ApiResponseModel } from 'app/_models/apiResponseModel';
import { Configuracao } from '../_models/configuracao';
import { RepairerManagerConfigurationPostResponseModel } from '../_models/repairerManagerConfigurationPostResponseModel';

declare const isEmpty: any;

@Component({
    selector: 'app-holding-config', templateUrl: './holding-config.component.html', styleUrls: ['./holding-config.component.scss'],
    standalone: false
})
export class RepairerManagerHoldingConfigComponent implements OnInit {
    public limite_minimo_auditoria: number = 0;
    public submitted: boolean = false;
    public hasError: boolean = false;

    constructor(private notificationService: NotificationService, private holdingConfigService: RepairerManagerHoldingConfigService, private globals: Globals, private ngxLoader: NgxUiLoaderService) { }

    ngOnInit() {
        this.buscarConfiguracoes(1);
    }

    modelChange() { }

    buscarConfiguracoes(nAttempts: number) {
        this.submitted = false;
        this.hasError = false;

        this.ngxLoader.startLoader('loader-principal');
        this.holdingConfigService.get().subscribe({
            next: (response: ApiResponseModel<Configuracao>) => {
                if (!isEmpty(response) && response.success) {
                    this.limite_minimo_auditoria = response.result.limite_minimo_auditoria;
                }

                this.ngxLoader.stopLoader('loader-principal');
            },
            error: error => {
                nAttempts = nAttempts || 1;
                console.log(error, nAttempts);

                if (nAttempts >= 5) {
                    this.ngxLoader.stopLoader('loader-principal');
                    this.notificationService.showErrorToastr(this.globals.translate('repairer-manager.configuracoes.mensagens.erro.carregamento.corpo'));
                    return;
                }

                this.buscarConfiguracoes(++nAttempts);
            }
        });
    }

    salvar(nAttempts: number) {
        this.submitted = true;

        if (!this.limite_minimo_auditoria || this.limite_minimo_auditoria < 10) {
            this.hasError = true;
            return;
        }

        this.hasError = false;
        this.ngxLoader.startLoader('loader-principal');

        this.holdingConfigService.post(this.limite_minimo_auditoria).subscribe({
            next: async (response: ApiResponseModel<RepairerManagerConfigurationPostResponseModel>) => {
                if (response != null) {
                    if (response.result.status)
                        this.notificationService.showSuccessToastr(this.globals.translate('repairer-manager.configuracoes.mensagens.sucesso.corpo'));
                    else
                        await this.notificationService.showWarning('repairer-manager.configuracoes.mensagens.erro.corpo', 'repairer-manager.configuracoes.mensagens.erro.titulo');

                    this.submitted = false;
                    this.ngxLoader.stopLoader('loader-principal');
                }
            },
            error: error => {
                nAttempts = nAttempts || 1;
                console.log(error, nAttempts);

                if (nAttempts >= 5) {
                    this.notificationService.showErrorToastr(this.globals.translate('repairer-manager.configuracoes.mensagens.erro.corpo'));
                    this.ngxLoader.stopLoader('loader-principal');
                    this.submitted = false;

                    return;
                }

                this.salvar(++nAttempts);
            }
        });
    }
}
